import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { SeasonFormComponent } from '../season-form/season-form.component';
import { Store } from '@ngxs/store';
import { ResetSeasonForm, ResetStepper } from '../../../state/season-form/season-form.action';
import { ResetSeason } from '../../../state/season/season.action';

@Component({
    selector: 'app-season-create',
    imports: [SeasonFormComponent],
    host: { class: 'block h-full' },
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<app-season-form mode="create"></app-season-form>`
})
export class SeasonCreateComponent implements OnInit {
    private store = inject(Store);

    ngOnInit(): void {
        this.store.dispatch([new ResetSeason(), new ResetStepper(), new ResetSeasonForm()]);
    }
}
